module.exports = __webpack_public_path__ + "static/img/footer-logo.92ea7ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer-logo.png
// module id = DSQX
// module chunks = 22